import config from "../../config"
import RequestService from "../RequestService"

const fetchOrganizations = (successCallback, failureCallback) => {
  RequestService.get(`${config.backendUrl}/organizations`, successCallback, failureCallback)
}

export default fetchOrganizations;